<div class="frozen-elements" *ngIf="hasFrozenEnrollment">
  <img [src]="'../../assets/images/yellow_sun.svg'" class="icon" />
  <h2 class="frozen-text" *ngIf="!isStarter">
    Dashboards show {{ getCurrentYearTwoDigit() - 1 }}-{{
      getCurrentYearTwoDigit()
    }}
    data until the first school starts the new year. Students' school and class
    enrollments will reflect {{ getCurrentYearTwoDigit() }}-{{
      getCurrentYearTwoDigit() + 1
    }}
    at least 14 days before, unless your administrator specified otherwise.
  </h2>
  <h2 class="frozen-text" *ngIf="isStarter">
    Dashboards show {{ getCurrentYearTwoDigit() - 1 }}-{{
      getCurrentYearTwoDigit()
    }}
    data, class enrollments and students' schools until the first school starts
    the new year.
  </h2>
</div>
